import { AxiosError } from "axios";
import { Container, Input, Link, SizeValue, Stack, Text } from "basis";
import { MutationFunction, useMutation } from "react-query";

type Props = {
  resendMutationFn: MutationFunction;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onResendCodeError: (e: AxiosError<any>) => void;
  otpRecipient: string;
  name?: string;
  label?: string;
  codeLength?: number;
  width?: SizeValue;
  resendCodeTimeout?: number;
  hasContactUsLink?: boolean;
  isMobileOtp?: boolean;
  showResend?: boolean;
};

export const OneTimeCode = ({
  otpRecipient,
  name = "oneTimeCode",
  label = "Verification code",
  isMobileOtp = true,
  codeLength = 4,
  width = "320",
  showResend = true,
  resendMutationFn,
  resendCodeTimeout = 5000,
  onResendCodeError,
  hasContactUsLink = true,
}: Props) => {
  const resendCodeMutation = useMutation(resendMutationFn, {
    onSuccess: () => {
      setTimeout(resendCodeMutation.reset, resendCodeTimeout);
    },
    onError: onResendCodeError,
  });

  return (
    <Stack gap="4">
      <Text>
        We’ve just sent a verification code to{" "}
        <strong>{otpRecipient.toLowerCase()}</strong>
        .
        <br />
        Please enter the {codeLength} digit code.
      </Text>

      <Stack gap="2" width={width}>
        <Input
          name={name}
          label={label}
          variant="numeric"
          maxLength={codeLength}
          autoComplete="one-time-code"
        />
        {showResend && (
          <Container textStyle="body2">
            <Stack gap="2" direction="horizontal">
              <Text>Not received your code yet?</Text>
              {resendCodeMutation.isLoading && (
                <Text>
                  <strong>Sending...</strong>
                </Text>
              )}
              {resendCodeMutation.isSuccess && (
                <Text color="conditional.positive.text">
                  <strong>Code sent</strong>
                </Text>
              )}
              {/* TODO: Shouldn't need the <Text textStyle="body2"> wrapper. Need to fix basis. */}
              {resendCodeMutation.isIdle && (
                <Text textStyle="body2">
                  <Link
                    href=""
                    newTab={false}
                    onClick={(e) => {
                      e.preventDefault();
                      // @ts-ignore
                      resendCodeMutation.mutate();
                    }}
                  >
                    Resend code
                  </Link>
                </Text>
              )}
            </Stack>
            {hasContactUsLink && (
              <Text>
                or{" "}
                <Link href="/contact" newTab={false}>
                  contact us
                </Link>{" "}
                to update your phone number
              </Text>
            )}
          </Container>
        )}
      </Stack>
    </Stack>
  );
};
